import Layout from "../../../components/layout/layout.js";

import CollegeLevel from "../../../components/componentsPage/collegeLevelDropdown/index.js";

function CollegeLevelPage({ component, ...rest }) {
  return (
    <Layout Component={CollegeLevel} controlsDisabled={true} {...rest} />
  );
}

export default CollegeLevelPage;
